import { getPreferredPhone, useDeleteContact, useGetAllContacts, useGetContact, useUpdateContact } from "@api/contactService";
import React, { useContext, useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ObjectShow from "@components/objects/ObjectShow";
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import ObjectColumn from "@components/objects/ObjectColumn";
import { ObjectPrimaryInfo } from "@components/objects/ObjectPrimaryInfo";
import Avatar from "@mui/joy/Avatar";
import { ObjectContext } from "@providers/ObjectProvider";
import { ensureDateObject, formatAbsoluteDate, formatDate, isValidDate } from "@utils/dates";
import ObjectPreview from "@components/objects/ObjectPreview";
import { generateAddress } from "@utils/generateAddress";
import { CardOverflow, List, ListDivider, ListItem, ListItemContent, ListItemDecorator, Table } from "@mui/joy";
import AbstractObjectRelationship from "@components/objects/AbstractObjectRelationship";
import UserAccessCard from "@components/objects/UserAccessCard";
import { intervalToDuration } from "date-fns";
import ObjectEdit from "@components/objects/ObjectEdit";
import { ObjectPrimaryInfoEdit } from "@components/objects/ObjectPrimaryInfoEdit";
import { ObjectRelationshipEdit } from "@components/objects/ObjectRelationshipEdit";
import { countries } from "@utils/selectOptions";
import { ObjectRelationship } from "@components/objects/ObjectRelationship";
import SearchSelect from "@components/SearchSelect";
import { CheckPermission } from "@components/CheckPermission";
import { useDeleteEvent, useGetEvent, useUpdateEvent } from "@api/eventService";



// import { DynamicFieldData } from "./dynamic-control-types";

const fields = [
    {
        name: 'name',
        type: 'text',
        placeholder: 'e.g. Trufflefest',
        showRequired: true,
        config: {
            required: true,
        },
    },
    {
        name: 'event_category_id',
        label: 'Category',
        type: 'relationship',
        endpoint: 'event-categories',
        defaultProp: 'event_category',
        loadAll: true,
    },
    {name: 'location', type: 'text', placeholder: 'e.g. Conductor Park'},
    {name: 'attendance', type: 'number', placeholder: 'e.g. 500'},
    {name: 'summary', type: 'textarea', placeholder: 'Summary...'},
];

export default function EventEdit(props) {
    return (
        <ObjectEdit
            query={useGetEvent}
            mutation={useUpdateEvent}
            deleteMutation={useDeleteEvent}
            type={'event'}
            permissionType={'events'}
            title={'Edit Event'}
            subtitleKey={'name'}
            color={'event'}
            {...props}
        >
            <ObjectColumn primary>
                <ObjectPrimaryInfoEdit
                    title={'Event Info'}
                    tint={'event'} // contact
                    fields={fields}
                />

                <ObjectRelationshipEdit type={'notes'} column={'description'} title={'Description'} />
            </ObjectColumn>

            <ObjectColumn>
                <ObjectRelationshipEdit type={'dates'} />
            </ObjectColumn>

            <ObjectColumn>
                <ObjectRelationshipEdit type={'workplans'} />
                <ObjectRelationshipEdit type={'files'} />
            </ObjectColumn>

        </ObjectEdit>
    )
}
